import { Popconfirm } from "@libertify/ui";
import { useTranslate } from "hooks/useTranslate/";
import { useTemplateEditorStore } from "../../storyboardEditor/store/useTemplateEditorStore";
import { useTemplatesStatusStore } from "../../storyboardEditor/store/useTemplatesStatusStore";
import { TemplateState } from "../../storyboardEditor/types";
import { CTAButton } from "../../storyboardEditor/components/StoryboardMenuTabs/CTAButton";
import { useCallback } from "react";

export const ThemeApplyToAllButton = ({
  partialTemplateState,
  filter,
  elementName,
}: {
  partialTemplateState: Partial<TemplateState>;
  filter: (template: TemplateState) => boolean;
  elementName: string;
}) => {
  const t = useTranslate();

  const { templates, currentSlide, setTemplates } = useTemplateEditorStore(
    (store) => ({
      templates: store.templates,
      currentSlide: store.currentSlide,
      setTemplates: store.setTemplates,
    })
  );

  const addTemplateUpdate = useTemplatesStatusStore(
    (store) => store.addTemplateUpdate
  );

  const handleApplyToAll = useCallback(() => {
    const targetIds: string[] = [];
    templates.forEach((template, id) => {
      if (id !== currentSlide && filter(template)) {
        targetIds.push(id);
      }
    });
    if (targetIds.length > 0) {
      setTemplates(targetIds, partialTemplateState);
      addTemplateUpdate();
    }
  }, [
    templates,
    currentSlide,
    filter,
    setTemplates,
    partialTemplateState,
    addTemplateUpdate,
  ]);

  return (
    <Popconfirm
      title={t("media.themeEditor.applyToAllConfirm", {
        element: elementName,
      })}
      onConfirm={handleApplyToAll}
    >
      <CTAButton>{t("media.themeEditor.applyToAll")}</CTAButton>
    </Popconfirm>
  );
};
